import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import { Table } from 'react-bootstrap';

class Documents extends Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            transactionsArray: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        let transactionsArray = [];
        props.transactions && props.transactions.map(transaction => transactionsArray.push(transaction));

        return {
            transactionsArray: transactionsArray
        }
    }

    componentDidMount(){
        this.props.startLoadingMemberFutureStrategy(this.props.match.params.usrMemberSetId);
    }

    render(){
        
        const { t } = this.props

        const documents = this.props.member.documents
        return (
            <div>
                <h2 style={{color: "#52800a", fontSize:"21.3333px", marginLeft: "10px"}}>{t('memberSite:documents')}</h2>
                <div  style={{marginTop:"-10px", marginLeft: "10px", fontSize: "12px"}}>
                    <p>{t('document:description:part1')}</p>
                    <p>{t('document:description:part2')}</p>
                </div>
                
                <table responsive id="FundDetailsTab" style={{ marginLeft: "-1px", marginRight: "1px" }}
                    className="table-responsive superlifeLegacyPlan">
                    <thead>
                        <th style={{ height: 20, textAlign:"left" }}>Document</th>
                        <th style={{ height: 20 }}>Date sent/received</th>
                    </thead>
                    <tbody>
                        {
                            documents.map(document =>
                                <tr style={{ lineHeight: 1.5 }}>
                                    <th style={{
                                        fontWeight: "normal", 
                                        textAlign:"left"
                                    }}><a href={document.basePath.replace('/adv','/slc') + document.imgServletSrc}>{document.description}</a></th>
                                    <th style={{
                                        fontWeight: "normal"
                                    }}>{document.receivedDate}</th>
                                    
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}
export default withTranslation()(Documents);